import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {
  AuthService,
  CacheService,
  IQueryResult,
  SearchExpression,
  SKIP_ERROR_HEADER_KEY,
  SortExpression,
  sort,
  IQueryService,
  Key,
} from '@kpd/framework-ngx';
import { apiUrl } from 'environments/environment';
import { License } from 'app/shared/models/license';
import { User } from 'app/shared/models/user';
import { IUserDTO } from './user.service';
import { Observable } from 'rxjs';
import { UserManagementQueryService } from 'app/shared/services/usermanagement.query.service';

export interface ILicenseDTO {
  quantity: number;
  quantityAssigned: number;
  clientIds: string[];
  purchaseDateTime: string;
  validFromDateTime: string;
  validUntilDateTime: string;
  licenseId: string;
  isValid: boolean;

  applications: {
    name: string;
    description?: string;
    version?: string;
  }[];

  name: string;
  state: string;
}

// export interface IApplicationWithLicenses {
//   name: string;
//   description: string;
//   licenses: ILicenseDTO[];
// }

@Injectable()
export class LicenseService extends UserManagementQueryService implements IQueryService {
  constructor(httpClient: HttpClient, cache: CacheService, private authService: AuthService) {
    super(httpClient, cache, '_license');
  }

  get tenant(): string {
    return this.authService.getTenant().key.toString();
  }

  // private createLicensesFromApps(apps: IApplicationWithLicenses[]): License[] {
  //   let licenses: License[] = [];
  //   apps.forEach((dto) => {
  //     dto.licenses.forEach((license) => {
  //       const addedLicense = new License({ ...license, application: { name: dto.name } });
  //       licenses.push(addedLicense);
  //     });
  //   });
  //   licenses = sort(licenses, [
  //     { name: 'application.name' },
  //     { name: 'isExpired' },
  //     { name: 'validUntilDate' },
  //     { name: 'validFromDate' },
  //   ]);
  //   return licenses;
  // }

  // /** @deprecated */
  // private getLicenses(): Observable<License[]> {
  //   return this.httpClient.get<IApplicationWithLicenses[]>(`${apiUrl()}/tenants/${this.tenant}/licenses`).pipe(
  //     map((applicationLicensesDTO) => {
  //       return this.createLicensesFromApps(applicationLicensesDTO);
  //     }),
  //   );
  // }

  getLicenses(): Observable<License[]> {
    return this.httpClient.get<ILicenseDTO[]>(`${apiUrl()}/tenants/${this.tenant}/licenses2`).pipe(
      map((dtos) => {
        const entities = dtos.map((dto) => new License(dto));
        return sort(entities, [
          { name: 'name' },
          { name: 'isExpired' },
          { name: 'validUntilDate' },
          { name: 'validFromDate' },
        ]);
      }),
    );
  }

  // /** @deprecated */
  // getTenantLicenses(): Observable<License[]> {
  //   return this.httpClient.get<IApplicationWithLicenses[]>(`${apiUrl()}/tenants/${this.tenant}/licenses`).pipe(
  //     map((applicationLicensesDTO) => {
  //       return this.createLicensesFromApps(applicationLicensesDTO);
  //     }),
  //   );
  // }

  // /** @deprecated */
  // getLicenseUsers(key: LicenseKey): Observable<User[]> {
  //   return this.httpClient
  //     .get<IUserDTO[]>(
  //       `${apiUrl()}/tenants/${this.tenant}/applications/${key.applicationId}/licenses/${encodeURIComponent(
  //         key.licenseId,
  //       )}/users`,
  //     )
  //     .pipe(map((usersDTO) => usersDTO.map((dto) => new User(dto))));
  // }

  getLicenseUsers(key: Key<string>): Observable<User[]> {
    return this.httpClient
      .get<IUserDTO[]>(`${apiUrl()}/tenants/${this.tenant}/licenses/${encodeURIComponent(key.id)}/users`)
      .pipe(map((usersDTO) => usersDTO.map((dto) => new User(dto))));
  }

  getLicensesForUser(upn: string): Observable<License[]> {
    return this.httpClient
      .get<ILicenseDTO[]>(`${apiUrl()}/tenants/${this.tenant}/users/${encodeURIComponent(upn)}/licenses2`)
      .pipe(
        map((dtos) => {
          return dtos.map((dto) => new License(dto));
        }),
      );
  }

  createUserLicense(licenseKey: Key<string>, upn: string): Observable<any> {
    return this.httpClient.post(
      `${apiUrl()}/tenants/${this.tenant}/licenses/${encodeURIComponent(licenseKey.id)}/users/${encodeURIComponent(
        upn,
      )}`,
      {},
      { headers: new HttpHeaders().set(SKIP_ERROR_HEADER_KEY, ['409']) },
    );
  }

  deleteUserLicense(licenseKey: Key<string>, upn: string): Observable<any> {
    return this.httpClient.delete(
      `${apiUrl()}/tenants/${this.tenant}/licenses/${encodeURIComponent(licenseKey.id)}/users/${encodeURIComponent(
        upn,
      )}`,
      { headers: new HttpHeaders().set(SKIP_ERROR_HEADER_KEY, ['404']) },
    );
  }

  getById(key: Key<string>, clearCache: boolean = false): Observable<License> {
    return this.getDtoById(
      `tenants/${this.tenant}/licenses/${encodeURIComponent(key.id)}`,
      key.toString(),
      clearCache,
      (dto: any) => {
        return new License(dto);
      },
    );
  }

  get(
    _searchExpression?: SearchExpression,
    _sortExpression?: SortExpression,
    _skip?: number,
    _take?: number,
  ): Observable<IQueryResult> {
    return this.getLicenses().pipe(
      map((licenses) => {
        return { result: licenses, totalCount: licenses.length };
      }),
    );
  }
}
